export default __webpack_public_path__ + "media/createAccount.c24638f6.png";